export default "__VITE_ASSET__B3P7bCz___"